import React, { useState } from "react";

const ConsultBookingForm = () => {
  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
    license: "",
    location: "",
    experienceLevel: "",
    consultationTopics: "",
    preferredContact: "",
    availability: "",
    message: "",
  });

  const sendEmail = (event) => {
    event.preventDefault();
    // Formspree endpoint - you may want to use a different endpoint for consults
    const formEndpoint = "https://formspree.io/f/xpzvzqor"; // Replace with your endpoint

    fetch(formEndpoint, {
      method: "POST",
      body: JSON.stringify({
        ...state,
        formType: "Consult Booking",
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          alert("Consult request successfully submitted! We'll be in touch soon.");
          setState({
            name: "",
            email: "",
            phone: "",
            license: "",
            location: "",
            experienceLevel: "",
            consultationTopics: "",
            preferredContact: "",
            availability: "",
            message: "",
          });
        } else {
          response.json().then((data) => {
            if (Object.hasOwn(data, "errors")) {
              alert("There was an error submitting the form. Please try again.");
            }
          });
        }
      })
      .catch((error) => {
        alert("There was an error submitting the form. Please try again.");
      });
  };

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <div className="contact-form-container">
      <form onSubmit={sendEmail} className="contact-form">
        <div className="form-group">
          <label className="form-label">Name:</label>
          <input
            required
            type="text"
            name="name"
            value={state.name}
            onChange={handleChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Email:</label>
          <input
            required
            type="email"
            name="email"
            value={state.email}
            onChange={handleChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Phone:</label>
          <input
            required
            type="tel"
            name="phone"
            value={state.phone}
            onChange={handleChange}
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label className="form-label">License/Credentials:</label>
          <input
            type="text"
            name="license"
            value={state.license}
            onChange={handleChange}
            className="form-input"
            placeholder="e.g., LMHC, LPC, LCSW"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Location/State:</label>
          <input
            type="text"
            name="location"
            value={state.location}
            onChange={handleChange}
            className="form-input"
            placeholder="e.g., Washington, California"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Experience Level:</label>
          <select
            name="experienceLevel"
            value={state.experienceLevel}
            onChange={handleChange}
            className="form-select"
          >
            <option value="">Select experience level</option>
            <option value="Getting started">Getting started with immigration evaluations</option>
            <option value="Refining practice">Refining my immigration evaluation practice</option>
            <option value="Both">Both - getting started and refining</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Consultation Topics of Interest:</label>
          <textarea
            name="consultationTopics"
            value={state.consultationTopics}
            onChange={handleChange}
            className="form-textarea"
            placeholder="e.g., Getting started, marketing, referral relationships, time management, documentation, handling difficult cases, etc."
            rows="3"
          ></textarea>
        </div>
        <div className="form-group">
          <label className="form-label">Preferred Contact Method:</label>
          <select
            name="preferredContact"
            value={state.preferredContact}
            onChange={handleChange}
            className="form-select"
          >
            <option value="">Select preferred method</option>
            <option value="Email">Email</option>
            <option value="Phone">Phone</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Availability:</label>
          <textarea
            name="availability"
            value={state.availability}
            onChange={handleChange}
            className="form-textarea"
            placeholder="Please share your general availability (e.g., weekday mornings, evenings, weekends)"
            rows="2"
          ></textarea>
        </div>
        <div className="form-group">
          <label className="form-label">Additional Information:</label>
          <textarea
            name="message"
            value={state.message}
            onChange={handleChange}
            className="form-textarea"
            placeholder="Any additional information you'd like to share"
            rows="4"
          ></textarea>
        </div>
        <button type="submit" className="form-button">
          Request Consultation
        </button>
      </form>
    </div>
  );
};

export default ConsultBookingForm;

